import React, { FC, ReactElement } from 'react'
import styled, { useTheme } from 'styled-components'
import { device } from '../breakpoints'
// import DepthMapParallax from 'components/DepthMapParallax'

interface Props {
  title?: string
  lead?: string
  keywords?: string
  date?: string
  authors?: string
}
const Header: FC<Props> = ({
  keywords,
  title,
  lead,
  date,
  authors,
}): ReactElement => {
  const theme = useTheme()

  return (
    <Container>
      {/* <DepthMapParallax /> */}
      <TextContainer>
        <TextWidth>
          <>
            {title && (
              <TitleContainer>
                <Sup>{keywords}</Sup>
                <Title>{title}</Title>
              </TitleContainer>
            )}
            {lead && <Text>{lead}</Text>}
            {authors && <Authors>{authors}</Authors>}
            {date && <Date>{date}</Date>}
          </>
        </TextWidth>
      </TextContainer>
    </Container>
  )
}

const TextContainer = styled.div``

const TextWidth = styled.div`
  max-width: 800px;
  margin: 0 auto;
  color: var(--text-color);
`

const Container = styled.div`
  position: relative;
  margin: auto;
`

const TitleContainer = styled.h2`
  margin-top: 0;
  line-height: 1.15;
  text-align: center;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-bottom: 1.2rem;
    font-size: 2em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-bottom: 1.2rem;
    font-size: 3em;
  }
`

const Title = styled.span`
  font-family: var(--font-serif);
  font-weight: 600;
  display: block;
`

const Text = styled.h3`
  font-family: var(--font-sans-serif);
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  line-height: 1.4;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1.8rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 2rem;
  }
`

const Sup = styled.span`
  display: inline-block;
  min-width: 85%;
  margin-bottom: 0.8rem;
  font-size: 1.5rem;
  font-family: var(--font-sans-serif);
  line-height: 2rem;
  color: ${({ theme }) => theme.brandColor};

  &:before {
    display: inline-block;
    margin-right: 0.6rem;
    padding: 0.2rem 0.6rem;
    color: white;
    font-weight: 700;
    font-size: 1.2rem;
    font-family: var(--font-sans-serif);
    line-height: 1.5rem;
    letter-spacing: 0.025rem;
    white-space: nowrap;
    background-color: ${({ theme }) => theme.brandColor};
    content: 'Abo';
  }
`

const Authors = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.4rem;
  line-height: 1.2;
  margin-bottom: 0.5rem;
  // font-weight: bold;
  margin-top: 2rem;
  text-align: center;
`

const Link = styled.a`
  text-decoration: underline;
`

const Date = styled.div`
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  opacity: 0.65;
  line-height: 1.2;
`

const Legend = styled.div`
  font-size: 1.2rem;
  opacity: 0.5;
  max-width: 669px;
  margin: 0 auto;
  margin-bottom: 6rem;
`

export default Header
